export enum ColWidth {
	s = 70,
	m = 100,
	l = 150,
	xl = 200
}
